// @ts-nocheck
import { ApiParameter, patch } from "@insite/client-framework/Services/ApiService";

export interface SaveUserSetupProductSetsApiParameter extends ApiParameter {
    accountId: string;
    setsIds: string[];
}

export function saveUserSetupProductSets(parameter: SaveUserSetupProductSetsApiParameter) {
    return patch<any>(`/api/v1/users/${parameter.accountId}/product-sets`, parameter.setsIds);
}
